import { render, staticRenderFns } from "./PaymentMethodItemIcon.vue?vue&type=template&id=2994dcfe&scoped=true&"
import script from "./PaymentMethodItemIcon.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodItemIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodItemIcon.vue?vue&type=style&index=0&id=2994dcfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2994dcfe",
  null
  
)

export default component.exports